import Grid from "@mui/material/GridLegacy";
import ActionButton from "components/Buttons/ActionButton";
import EmailField from "components/EmailField";
import useNotifications from "features/Notifications/hooks/useNotifications";
import useCreateResetPasswordToken from "hooks/api/useCreateResetPasswordToken";
import useVidletNavigate from "hooks/navigation/useVidletNavigate";
import { useEffect, useState } from "react";
import { LOGIN_PAGE } from "utils/axiosInterceptors";
import isEmail from "utils/validators/isEmail";

function ForgotPassword() {
  const [email, setEmail] = useState<string | undefined>();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { navigate } = useVidletNavigate();
  const { setNotification } = useNotifications();
  const { createResetPasswordToken } = useCreateResetPasswordToken();

  useEffect(() => {
    setIsSubmitted(false);
  }, [email]);

  function onSignIn() {
    navigate(LOGIN_PAGE);
  }

  async function onSubmit() {
    if (!email) return;
    await createResetPasswordToken(email);

    setIsSubmitted(true);
    setNotification({
      message:
        "If your email is in our system, please check your inbox for a reset link.",
      autoHideDuration: undefined,
    });
  }

  return (
    <Grid container flexDirection="column" spacing={1}>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <EmailField
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <ActionButton
          disabled={!email || !isEmail(email) || isSubmitted}
          fullWidth
          onClick={onSubmit}
        >
          Submit
        </ActionButton>
      </Grid>
      <Grid item xs={12}>
        <ActionButton fullWidth onClick={onSignIn}>
          Sign In
        </ActionButton>
      </Grid>
    </Grid>
  );
}

export default ForgotPassword;
